import { NavigationItem } from "./navigation-item.model";

export class NavigationSection {
    constructor(public title: string, public navigationItems: Array<NavigationItem>) {}
  }